module.exports = __webpack_public_path__ + "img/template.9bf8f976.png";